export default "__VITE_ASSET__J4_W62LP__"